<template>
  <v-container fluid fill-height class="loginOverlay">
    <v-layout flex align-center justify-center>
      <v-flex xs12 sm4 elevation-6>
        <v-toolbar class="pt-5 blue darken-4">
          <v-toolbar-title class="white--text"
            ><h4>Добро пожаловать !</h4>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
          <v-card-text class="pt-4">
            <span v-if="errorText" class="red--text"
              >Неправильный логин или пароль</span
            >
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="Введите Ваш email"
                v-model="email"
                type="email"
                :rules="global.rules.email"
                required
              ></v-text-field>
              <v-text-field
                label="Введите Ваш пароль"
                v-model="password"
                min="8"
                type="password"
                :rules="[global.rules.required]"
                counter
                required
              ></v-text-field>
              <v-layout justify-space-between>
                <v-btn
                  @click="useLogin"
                  :class="{
                    'blue darken-4 white--text': valid,
                    disabled: !valid
                  }"
                  >Login</v-btn
                >
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { GLOBAL } from "@/config/consts";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      valid: false,
      password: "",
      email: "",
      multiLine: true,
      snackbar: false,
      errorText: "",
      global: GLOBAL
    };
  },
  computed: {
    ...mapGetters(["getErrorText"])
  },
  methods: {
    ...mapActions(["login"]),
    async useLogin() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const username = this.email;
      const password = this.password;

      try {
        await this.login({ username, password });
        await this.getUser();
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      }
    },
    async getUser() {
      try {
        const { data } = await this.$axios.get(GLOBAL.apiUrl.user);
        this.$store.commit("set_user", data);
        await this.$router.push({ path: "/" });
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      }
    }
  }
};
</script>
